module.exports = __webpack_public_path__ + "static/img/icon_lead.f323768.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_lead.svg
// module id = 393
// module chunks = 12